import React from 'react';
import styled from 'styled-components';

const TRACK_WIDTH = 16;

const Track = styled.span<{ $interactive: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${TRACK_WIDTH}px;
  height: 12px;
  flex: 0 0 auto;
  cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'default')};
  transform-origin: center;
  transition: transform 0.1s ease;

  &:hover {
    transform: ${({ $interactive }) => ($interactive ? 'scale(1.3)' : 'none')};
  }
`;

const Bar = styled.span<{ $color: string; $isSelected: boolean }>`
  width: 100%;
  height: ${({ $isSelected }) => ($isSelected ? 3 : 2)}px;
  border-radius: 2px;
  background: ${({ $color }) => $color};
  opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0.3)};
  transition:
    height 0.15s ease,
    opacity 0.15s ease;

  ${Track}:hover & {
    opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0.6)};
  }
`;

interface SeriesColorLineProps {
  /** Series color, or undefined when the row has no charted series (renders an empty track). */
  color: string | undefined;
  /** Whether the series is currently rendered on the chart. */
  isSelected: boolean;
}

/**
 * Legend indicator for a series. The series color is always shown so color identity is never lost;
 * selection state is carried by line weight and alpha (3px solid vs. 2px at 30% alpha).
 */
function SeriesColorLine({ color, isSelected }: SeriesColorLineProps) {
  return (
    <Track $interactive={Boolean(color)} aria-hidden>
      {color && <Bar $color={color} $isSelected={isSelected} />}
    </Track>
  );
}

export default SeriesColorLine;
